import React from "react";
import "./Get_In_Touch.css";
import { Link } from "react-router-dom";

const Get_In_Touch = (props) => {
  return (
    <section className="Get_In_Touch">
      <div className="container">
        <div className="main_img_holder">
          <div className="img_holder">
            <img
              src={
                process.env.PUBLIC_URL +
                `${
                  props?.getInTouch_Img
                    ? props?.getInTouch_Img
                    : "/Assets/Images/Service/Services/Video_Wala_Bus_Stand/Get_In_Touch/common.png"
                }`
              }
            />
          </div>
          <div className="overlay_holder"></div>

          {props?.vidowala === true ? (
            <div className="text_holder">
              <div className="row">
                <div className="col-lg-8 col-md-8 col-sm-12">
                  <p className="hedaing">
                    Make your brand the talk of the town -
                  </p>
                  <p className="sub_text">
                    connect with ReachOut Media today and watch your business
                    today!
                  </p>
                </div>
              </div>
            </div>
          ) : (
            <div className="text_holder">
              <div className="row">
                <div className="col-lg-8 col-md-8 col-sm-12">
                  <p className="hedaing2">
                    {props?.getInTouch_Title}
                    {props?.getInTouch_Titl2}
                  </p>
                  <p className="sub_text2">{props?.getInTouch_Descn}</p>
                </div>
              </div>
            </div>
          )}

          <Link to={"/contact-us"}>
            <div className="btn_holder">
              <button className="btn">Get in Touch</button>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Get_In_Touch;
